<template>
    <div class="main">
        <div v-if="showSpinner" class="spinner-border text-primary" role="status" style="width: 10rem; height: 10rem;">
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, provide } from 'vue';
    import { useCommonStore } from '../store/useCommonStore';
    import router from '../router';
    import { Userpilot } from 'userpilot'
    const showSpinner = ref(true);
    const store = useCommonStore();

    let fetchData = () => {
        fetch('api/account/token')
            .then(r => {
                if (!r.ok) {
                    showSpinner.value = false;
                    router.push({ path: '/' })
                }
                return r.json();
            })
            .then(json => {
                showSpinner.value = false;
                store.setToken('token', json);
                if (process.env.VUE_APP_UserpilotEnabled === 'true' || window.__env?.VUE_APP_UserpilotEnabled === 'true') {
                    Userpilot.identify(json.userId, {
                        name: json.displayName,
                        email: json.email,
                        company: {
                            id: json.contextUser.ServiceId, 
                            name: json.serviceProviderName
                        }
                    })
                }
                router.push({ path: '/' })
            });
    }

    onMounted(() => {
        fetchData();
    })
</script>
